<div class="col-md-12">
  <h2 class="heading" style="margin-bottom: 0px">
    <span>{{'_PatientsReminderSettingsHeader_' | translate}}</span>
  </h2>
  <p style="margin-top: 8px; padding-left: 2px">If the reason for an appointment is not mapped to a strategy then reminders are sent by
    the strategy defined below for the <span style="text-transform: lowercase">{{'_Patient_' | translate}}</span>.</p>

  <div class="form-group">
    <label class="col-md-1 control-label">Strategy:</label>
    <div class="col-md-5">
      <p-dropdown
          [options]="strategies"
          [ngModel]="selectedPatientStrategy"
          optionLabel="strategyName"
          placeholder="Select a Strategy"
          [showClear]="false"
          styleClass="form-control"
          (onChange)="strategyChanged.emit($event.value)"
          [style]="{'font-size': '14px', 'color': '#555', 'background': '#ffffff' ,'font-family':'Helvetica Neue,Helvetica,Arial,sans-serif'}"
      >
      </p-dropdown>
    </div>
  </div>

</div>
